import { BroadcastChannel } from 'broadcast-channel';

type Message = ConnectingMessage | ConnectionAcceptedMessage;

export class ConnectingMessage {
  type = 'CONNECTING' as const;
  constructor(
    public environment: string,
    public quoteId: string | null,
    public rfqId: string | null,
  ) {}
}

export class ConnectionAcceptedMessage {
  type = 'CONNECTED' as const;
  constructor(public environment: string) {}
}

type OnMessageCallback = (message: Message) => void;

interface MessageBus {
  postMessage(message: Message): void;
  onMessage(callback: OnMessageCallback): void;
  close(): void;
}

// Connect to the channel named "sp_bus".
const channel = new BroadcastChannel('sp_bus');

export const bus = <MessageBus>{
  postMessage(message) {
    channel.postMessage(message);
  },
  onMessage(callback) {
    channel.onmessage = function (e: Message) {
      callback(e);
    };
  },
  close() {
    channel.close();
  },
};
